import { useMemo } from 'react'

import { EventData, EventStatus, EventType } from '~/gamification/types/gamification.types'
import { selectEvents } from '~/gamification/slices/gamification.slice'

import { useAppSelector } from '~/redux/hooks'

export default function useGetCompletedQuests(): EventData[] | undefined {
  const events = useAppSelector(selectEvents)

  const completedQuests = useMemo(
    () =>
      events?.filter((event) => {
        return (
          event.type &&
          [EventType.CHAMPIONSHIP, EventType.QUEST].includes(event.type) &&
          event.status === EventStatus.COMPLETED
        )
      }),
    [events],
  )

  return completedQuests
}
